module.exports = __webpack_public_path__ + "static/media/close-white.37ec7b60.svg";